module.exports = __webpack_public_path__ + "static/ecoducktoy-be2b3eb3584af0502ab36bbf7cef7af7.jpeg";